"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFormProgressNav = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var TypeFormProgressNav = function (props) {
    var steps = props.steps, active = props.active;
    var status = function (index, activeIndex) {
        if (index < activeIndex) {
            return 'Completed';
        }
        else if (index > activeIndex) {
            return 'To do';
        }
        else {
            return 'In progress';
        }
    };
    return (React.createElement("div", { className: "typeFormProgressNav" },
        React.createElement("h2", { className: "sr-only" }, "Progress bar"),
        React.createElement("ul", { className: "typeForm--progress-list list-unstyled" }, steps.map(function (step, i) {
            return (React.createElement("li", { key: step, className: "typeForm--progress-item" + (active === i ? ' active' : '') },
                React.createElement("span", { className: "typeForm--step" }, step),
                React.createElement("span", { className: "typeForm--status" }, status(i, active)),
                React.createElement("span", { className: "typeForm--progress" }, "Step " + (i + 1) + " of " + steps.length)));
        }))));
};
exports.TypeFormProgressNav = TypeFormProgressNav;
exports.TypeFormProgressNav.defaultProps = {
    screenReaderHeading: 'Progress bar',
};
exports.TypeFormProgressNav.propTypes = {
    active: PropTypes.number.isRequired,
    screenReaderHeading: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};
